<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://www.flyhigh.my" target="_blank">FLYHIGH</a>
      <span class="ml-1">&copy; 2021 FLYHIGH Teams.</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Powered by</span>
      <a href="https://www.flyhigh.my" target="_blank">FLYHIGH</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
